<div class="flex-auto block" [ngClass]="classNames()">
  <label [for]="for()" class="block mb-2 text-white font-[500] tracking-wide"
    [ngClass]="[labelClassNames(), required ? 'required' : '']">
    {{ label() }}:
  </label>
  <ng-content></ng-content>
  @if(control?.invalid && (control?.dirty || control?.touched)){
  <small class="text-red-500 block mt-1">
    {{getErrorMessage()}}
  </small>
  }
</div>